module.exports = __webpack_public_path__ + "ca4f271e39a25796a1162dcf1441e0eb.svg";